import { isSuscriptor } from '../services/wallService';
import { flowDefault } from "../helpers/flow";
import { flowSuscriptor } from "./flow/flowSuscriptor";
import { flowNoSuscriptor} from "./flow/flowNoSuscriptor";

const flow = (data, isPdf = false) => {
    const flowFunction = isSuscriptor() ? flowSuscriptor : flowNoSuscriptor;
    flowFunction(data.code, isPdf);
}

export default {
    flowDefault,
    flow
};




// WEBPACK FOOTER //
// ./Statics/scripts/paywall/handlers/flow.js